import { render } from "./WeeklyReport.vue?vue&type=template&id=b6f5c534"
import script from "./WeeklyReport.vue?vue&type=script&lang=ts"
export * from "./WeeklyReport.vue?vue&type=script&lang=ts"
script.render = render

export default script